export default __webpack_public_path__ + "static/media/birthday-celebrations.79dee039.svg";